import React from 'react';
import { showPopup } from '@/components/PopupContainer/popupService';
import InviteFlowModal, { INVITE_FLOW_POPUP_ID } from '../ui/InviteFlowModal';

export const openInvite = () => {
   showPopup({
      id: INVITE_FLOW_POPUP_ID,
      hideHeader: true,
      body: React.createElement(InviteFlowModal),
      className: 'invite-flow-popup-modal',
      visible: true,
   });
};
